import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TypewriterText = ({
  texts = [],
  speed = 80,
  deleteSpeed = 40,
  pause = 2000,
  className = '',
  onComplete,
}) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isFirstComplete, setIsFirstComplete] = useState(false);

  const tick = useCallback(() => {
    const fullText = texts[currentTextIndex] || '';

    if (!isDeleting) {
      const next = fullText.substring(0, displayText.length + 1);
      setDisplayText(next);

      if (next === fullText) {
        if (!isFirstComplete) {
          setIsFirstComplete(true);
          onComplete?.();
        }
        if (texts.length > 1) {
          setTimeout(() => setIsDeleting(true), pause);
        }
        return;
      }
    } else {
      const next = fullText.substring(0, displayText.length - 1);
      setDisplayText(next);

      if (next === '') {
        setIsDeleting(false);
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        return;
      }
    }
  }, [currentTextIndex, displayText, isDeleting, texts, pause, onComplete, isFirstComplete]);

  useEffect(() => {
    const timeout = setTimeout(tick, isDeleting ? deleteSpeed : speed);
    return () => clearTimeout(timeout);
  }, [tick, isDeleting, deleteSpeed, speed]);

  return (
    <span className={className}>
      <AnimatePresence mode="wait">
        <motion.span
          key={displayText}
          initial={{ opacity: 0.8 }}
          animate={{ opacity: 1 }}
        >
          {displayText}
        </motion.span>
      </AnimatePresence>
      <motion.span
        animate={{ opacity: [1, 0] }}
        transition={{ duration: 0.5, repeat: Infinity, repeatType: 'reverse' }}
        className="inline-block w-[3px] h-[1em] bg-current ml-0.5 align-middle"
      />
    </span>
  );
};

export default TypewriterText;
